import * as React from "react";

import { alpha } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import AppNavbar from "../components/AppNavbar";
import Header from "../components/Header";
import MainGrid from "../components/MainGrid";
import SideMenu from "../components/SideMenu";
import AppTheme from "../shared-theme/AppTheme";
import { chartsCustomizations, dataGridCustomizations, datePickersCustomizations, treeViewCustomizations } from "../theme/customizations";
import MainWithdrawal from "../components/withdrawal/MainWithdrawal";
import TwoFactorAuth from "../components/security/TwoFactorAuth";
import ChangePassword from "../components/security/ChangePassword";
import Reports from "../components/reports/ReportsMain";
import CustomerDeposits from "../components/reports/CustomerDeposit";
import CustomerMainWithdrawal from "../components/withdrawal/CustomerMainWithdrawal.js";
import AgentWithdrawals from "../components/reports/AgentWithdrawal";
import CustomerList from "../components/customer/CustomerList";
import AgentCryptoCurrencies from "../components/crypto/AgentCryptoCurrencies";
import WithdrawalRequestMain from "../components/withdrawal/WithdrawalRequestMain";
import MainDepositAgent from "../components/deposits/MainDepositAgent.js";
import AgentDeposits from "../components/reports/AgentDeposits.js";
import MainTransfer from "../components/transfer/MainTransfer.js";
import AgentTransfers from "../components/reports/AgentTransfers.js";
import MainAgentsList from "../components/maintenance/MainAgentsList.js";

const xThemeComponents = {
	...chartsCustomizations,
	...dataGridCustomizations,
	...datePickersCustomizations,
	...treeViewCustomizations,
};

export default function Dashboard(props) {
	const { isAuthenticated, setIsAuthenticated, option } = props;
	const profile = JSON.parse(localStorage.getItem("profile")) ?? {};
	const { token, id, username } = profile;
	return (
		<AppTheme {...props} themeComponents={xThemeComponents}>
			<CssBaseline enableColorScheme />
			<Box sx={{ display: "flex" }}>
				<SideMenu token={token} isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} username={username} />
				<AppNavbar token={token} username={username} />
				{/* Main content */}
				<Box
					component="main"
					sx={(theme) => ({
						flexGrow: 1,
						backgroundColor: theme.vars
							? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
							: alpha(theme.palette.background.default, 1),
						overflow: "auto",
					})}
				>
					<Stack
						spacing={2}
						sx={{
							alignItems: "center",
							mx: 3,
							pb: 5,
							mt: { xs: 8, md: 0 },
						}}
					>
						<Header />
						{option === 1 ? (
							<MainGrid token={token} id={id} isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} />
						) : option === 2 ? (
							<MainWithdrawal token={token} id={id} isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} />
						) : option === 3 ? (
							<TwoFactorAuth token={token} id={id} isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} />
						) : option === 4 ? (
							<ChangePassword token={token} id={id} isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} />
						) : option === 5 ? (
							<Reports token={token} id={id} isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} />
						) : option === 6 ? (
							<CustomerDeposits token={token} id={id} isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} />
						) : option === 7 ? (
							<CustomerMainWithdrawal token={token} id={id} isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} />
						) : option === 8 ? (
							<AgentWithdrawals token={token} id={id} isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} />
						) : option === 9 ? (
							<CustomerList token={token} id={id} isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} />
						) : option === 10 ? (
							<AgentCryptoCurrencies token={token} isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} />
						) : option === 11 ? (
							<WithdrawalRequestMain token={token} id={id} isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} />
						) : option === 12 ? (
							<MainDepositAgent token={token} id={id} isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} />
						) : option === 13 ? (
							<AgentDeposits token={token} id={id} isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} />
						) : option === 14 ? (
							<MainTransfer token={token} id={id} isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} />
						) : option === 15 ? (
							<AgentTransfers token={token} id={id} isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} />
						) : option === 16 ? (
							<MainAgentsList token={token} id={id} isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} />
						) : null}
					</Stack>
				</Box>
			</Box>
		</AppTheme>
	);
}
